import { HighlightConfig } from '../../infra';
import { getRuntimeEnv } from '../../infra';

function createHighlightConfig(): HighlightConfig | null {
    const runtimeEnv = getRuntimeEnv();

    // Skip Highlight initialization if projectId is not configured
    if (!runtimeEnv.highlightProjectId) {
        return null;
    }

    return {
        projectId: runtimeEnv.highlightProjectId,
    };
}

export const HIGHTLIGHT_CONFIG = createHighlightConfig();
